export const codeAPI = {
  // 메소드명 : selectItemCodeList(parentCode, depth)
  // ### 코드 조회 ###
  // 코드를 DB테이블에서 조회한다.
  //
  // 최초작성 : 2016.05.31
  // 파라미터 :
  //  - parentCode(그룹코드 값)
  //  - depth(대분류,소분류 구분)
  // *************************
  // ## 코드 히스토리 ##
  //    날짜    작성자     수정내용
  // 2019.05.31  황경현   최초작성
  // *************************
  selectItemCodeList: function(self, parentCode, depth, dataName){
    var codeItemDatas = [];
    var resultDatas = [];
    var depthXItems = [];
    var token = sessionStorage.getItem("myToken");
    self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=' + parentCode)
    .then((result) => {
      depthXItems = result.data;
      switch (depth) { // 몇번째 뎁스에 해당하는 코드리스트인지 파악
        case 2:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        case 3:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        case 4:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        default:
      }

      // codeItemDatas.forEach(function (el, idx, arr){
      //   var items = {
      //     text: el.item_name,
      //     value: el.item_code,
      //   };
      //   resultDatas.push(items);
      // });
      console.log(dataName);
      self[dataName] = codeItemDatas;
    })
  },
  // 메소드명 : selectItemCodeBackList(parentCode, depth)
  // ### 코드 조회 ###
  // 코드를 DB테이블에서 조회한후 역순으로 변경한다.
  //
  // 최초작성 : 2016.05.31
  // 파라미터 :
  //  - parentCode(그룹코드 값)
  //  - depth(대분류,소분류 구분)
  // *************************
  // ## 코드 히스토리 ##
  //    날짜    작성자     수정내용
  // 2019.05.31  황경현   최초작성
  // *************************
  selectItemCodeBackList: function(self, parentCode, depth, dataName){
    var codeItemDatas = [];
    var resultDatas = [];
    var depthXItems = [];
    var token = sessionStorage.getItem("myToken");
    self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=' + parentCode)
    .then((result) => {
      depthXItems = result.data;
      switch (depth) { // 몇번째 뎁스에 해당하는 코드리스트인지 파악
        case 2:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        case 3:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        case 4:
          codeItemDatas = self.$_.clone(depthXItems);
          break;
        default:
      }

      // codeItemDatas.forEach(function (el, idx, arr){
      //   var items = {
      //     text: el.item_name,
      //     value: el.item_code,
      //   };
      //   resultDatas.push(items);
      // });
      codeItemDatas.reverse();
      self[dataName] = codeItemDatas;
    })
  }
};



// WEBPACK FOOTER //
// ./src/common/code.js